"use strict";const e=require("@mui/material"),t=require("../code.org/index.js"),r=e.createTheme(t,{palette:{primary:{main:"#FF69B4",light:"#FF99CC",dark:"#CC5490",contrastText:"#FFFFFF"}}});module.exports=r;
//# sourceMappingURL=index.js.map
